import { render } from "./EmailCapture.vue?vue&type=template&id=b152049e"
import script from "./EmailCapture.vue?vue&type=script&lang=js"
export * from "./EmailCapture.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__